import type { ReactElement } from 'react';

import { Card, Flex, Heading, Separator, Skeleton, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { displayUserRankOrdinal } from '../../Profile/ProfileSummary/ProfileSummary.helpers';

import styles from './TopUserCard.module.css';

type TopUserCardSkeletonProps = {
  rank: number;
};

export function TopUserCardSkeleton(props: TopUserCardSkeletonProps): ReactElement {
  const { rank } = props;
  const { t } = useTranslation();

  return (
    <Card variant="surface" size="3" className={styles.card}>
      <Flex direction="column" gap="3" width="100%">
        <Flex justify="between" align="start" width="100%">
          <Flex direction="column" gap="0" align="center">
            <Heading size="7" weight="bold">
              {displayUserRankOrdinal(rank)}
            </Heading>
            <Text size="2" color="gray">
              {t('Rank')}
            </Text>
          </Flex>
          <Skeleton width="64px" height="64px" />
        </Flex>
        <Separator size="4" />
        <Flex justify="between" align="center" width="100%">
          <Skeleton width="149px" height="24px" />
          <Flex gap="1">
            <Skeleton width="24px" height="24px" />
            <Skeleton width="46px" height="24px" />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
